<app-service-state-form
    *ngIf="!loading"
    [title]="'pages.services-state.configuration.edit.header.title' | translate"
    [service]="service" 
    [submitLoading]="submitLoading"
    (submitForm)="handleSubmit($event)">
</app-service-state-form>